"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Filter the row keys by existence in the table
 * @param rowKeys to be filtered
 * @param tableView that used to be a reference
 * @returns filtered row keys if the key presents in the tableView.rowKeys
 */
function filterRowKeysByExistence(rowKeys, tableView) {
    return rowKeys.filter(function (rowKey) { return tableView.rowKeys.indexOf(rowKey) >= 0; });
}
exports.default = filterRowKeysByExistence;
//# sourceMappingURL=filterRowKeysByExistence.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/filterRowKeysByExistence.js
// module id = 3824
// module chunks = 62